import React, { ReactElement, useState } from 'react';

import { useIntl } from 'react-intl';

import styles from './user-info-styles.module.scss';

import { AnchorElement } from 'types';
import { Avatar } from 'views/components';
import { UserMenu } from 'views/components/AppHeader/UserMenu';

interface IUserInfo {
  imageUrl: string;
}

const UserInfo = React.memo((props: IUserInfo): ReactElement => {
  const { imageUrl } = props;

  const intl = useIntl();
  const [userAvatarAnchorEl, setUserAvatarAnchorEl] = useState<AnchorElement>(null);

  const onUserAvatarClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    setUserAvatarAnchorEl(e.currentTarget);
  };

  const onUserAvatarKeyDown = (e: React.KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setUserAvatarAnchorEl(e.currentTarget);
    }
  };

  const closeUserMenuPopover = (): void => setUserAvatarAnchorEl(null);

  return (
    <>
      <div className={styles['user-info']}>
        <div
          className={styles['user-info__avatar']}
          onClick={onUserAvatarClick}
          onKeyDown={onUserAvatarKeyDown}
          role="button"
          tabIndex={0}
          aria-label={intl.formatMessage({ id: 'user-info.avatar.button' })}
        >
          <Avatar
            size="tiny"
            mode="user"
            isActive={Boolean(userAvatarAnchorEl)}
            image={imageUrl}
          />
        </div>
      </div>

      {userAvatarAnchorEl && (
        <UserMenu anchorEl={userAvatarAnchorEl} handleClose={closeUserMenuPopover} />
      )}
    </>
  );
});

export { UserInfo };
